import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=2397691d&scoped=true"
import script from "./Structure.vue?vue&type=script&lang=js"
export * from "./Structure.vue?vue&type=script&lang=js"
import style0 from "./Structure.vue?vue&type=style&index=0&id=2397691d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397691d",
  null
  
)

export default component.exports